import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch } from "react-redux";
import { showCustomAlert } from "./User/Signup/Toast";
import { LoadUserSuccess } from "../redux/userSlice";
const MicrosoftCallback = () => {
  const navigate = useNavigate();
const dispatch = useDispatch();
  useEffect(() => {
    const processAuthCallback = () => {
      const urlParams = new URLSearchParams(window.location.search);
      const userId = urlParams.get("userId");
      const email = urlParams.get("email");
      const token = urlParams.get("token");
      const name = urlParams.get("name");

      if ( !email || !token) {
        console.error("Missing authentication parameters in URL");
    Cookies.get("selectedSlug") ? navigate(`/${Cookies.get("selectedSlug")}`) : navigate("/");
        return;
      }
const userdata = {
    name : name,
    email : email,
    _id : userId
    
}
    dispatch(LoadUserSuccess(userdata));
      // Save user details in localStorage
      localStorage.setItem("userId", userId);
      localStorage.setItem("email", email);

      // Store accessToken in cookies with an expiration date from cookies
     
      Cookies.set("accessToken", token);
       Cookies.set("refreshToken", token);
console.log("token",token)
if(token){
    console.log("Logined")
    showCustomAlert({
             title: "Welcome Back!",
             html: "<p style='color: #555;'>You have successfully logged in.</p>",
             icon: "success",
             confirmButtonText: "Continue",
             confirmButtonColor: "#af313d",
             background: "#ffffff",
           });
         
            
            Cookies.get("selectedSlug") ? navigate(`/${Cookies.get("selectedSlug")}`) : navigate("/");
            
           setTimeout(() => {
             window.location.reload()
           }, 1000);
}
    
    };

    processAuthCallback();
  }, [navigate]);

  return <p>Processing login...</p>;
};

export default MicrosoftCallback;
